import { styled } from '@mui/material/styles';

const style = {
    Container: styled('div')`
        background-color: #efefef;
        border-radius: 16px;
        display: flex;
        flex-direction: column;
        gap: 8px;
        justify-content: center;
        padding: 16px;
        width: 384px;
    `,
    Row: styled('div')`
        display: flex;
        flex-direction: row;
        gap: 8px;
        justify-content: center;
    `,
};

export default style;
